import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Suspense } from "react";
import { lazy } from "react";
import AdminPrivate from './adminPrivateRoute';
import { ToastContainer } from 'react-toastify';
import Loader from '../components/Loader';
import CreateOberserventUser from '../pages/CreateOberserventUser';
import useUserRole from '../hooks/useUserRole';
import TermsOfUse from '../pages/TermsOfUse';
import PrivacyPolicy from '../pages/PrivacyPolicy';

const MyRoutes = () => {
    const token = localStorage?.getItem("token");
    const roles = useUserRole()


    const Login = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Login")), 1300);
        });
    });


    const Dashboard = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Dashboard")), 1300);
        });
    });


    const Verification = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Verification")), 1300);
        });
    });


    const CreateSale = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/CreateSale")), 1300);
        });
    });


    const EditSale = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/EditSale")), 1300);
        });
    });


    // const Points = lazy(() => {
    //     return new Promise((resolve) => {
    //         setTimeout(() => resolve(import("../pages/Points")), 1300);
    //     });
    // });


    const SaleRepresentative = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/SaleRepresentative")), 1300);
        });
    });


    const SalesRepresentativeViewDetail = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/SalesRepresentativeViewDetail")), 1300);
        });
    });

    const Home = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Home")), 1300);
        });
    });

    const Signup = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Signup")), 1300);
        });
    });


    const Services = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Services")), 1300);
        });
    });


    const AllObservantsUsers = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/AllObservantsUsers")), 1300);
        });
    });


    const Logs = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Logs")), 1300);
        });
    });


    const ApprovalRequest = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/ApprovalRequest")), 1300);
        });
    });

    const AllRegionalManagers = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/AllRegionalManagers")), 1300);
        });
    });

    const CreateRegionalManager = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/CreateRegionalManager")), 1300);
        });
    });

    const RegionalManagerDetail = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/RegionalManagerDetail")), 1300);
        });
    });


    const Sales = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Sales")), 1300);
        });
    });

    const About = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/About")), 1300);
        });
    });


    const Press = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Press")), 1300);
        });
    });

    const Blog = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Blog")), 1300);
        });
    });

    const Help = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Help")), 1300);
        });
    });


    const Safety = lazy(() => {
        return new Promise((resolve) => {
            setTimeout(() => resolve(import("../pages/Safety")), 1300);
        });
    });

    const allRoutes = [
        {
            path: 'dashboard',
            element: <Dashboard />
        },
        // {
        //     path: 'points',
        //     element: <Points />
        // },
        {
            path: 'salesRepDetail',
            element: <SalesRepresentativeViewDetail />
        },
        {
            path: 'createSale',
            element: <CreateSale />
        },
        {
            path: 'editSale',
            element: <EditSale />
        },
        {
            path: 'saleRepresentative',
            element: <SaleRepresentative />
        },
        {
            path: 'services',
            element: <Services />
        },
        {
            path: 'allObservantsUsers',
            element: <AllObservantsUsers />
        },
        {
            path: 'createObservantUser',
            element: <CreateOberserventUser />
        },
        {
            path: 'logs',
            element: <Logs />
        },
        {
            path: 'approvalRequest',
            element: <ApprovalRequest />
        },
        {
            path: 'allRegionalManagers',
            element: <AllRegionalManagers />
        },
        {
            path: 'createManager',
            element: <CreateRegionalManager />
        },
        {
            path: 'sales',
            element: <Sales />
        },
        {
            path: 'regionalManagerDetail',
            element: <RegionalManagerDetail />
        },
    ];

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            <BrowserRouter>
                <Suspense fallback={<Loader />}>
                    <Routes>
                        {token ? <Route path="/dashboard" element={<Dashboard />}></Route> : <Route path="/home" element={<Home />}></Route>}
                        {!token && <Route path="/home" element={<Home />}></Route>}
                        {!token && <Route path="/about" element={<About />}></Route>}
                        {!token && <Route path="/press" element={<Press />}></Route>}
                        {!token && <Route path="/blog" element={<Blog />}></Route>}
                        {!token && <Route path="/help" element={<Help />}></Route>}
                        {!token && <Route path="/safety" element={<Safety />}></Route>}
                        {!token && <Route path="/termsOfUse" element={<TermsOfUse />}></Route>}
                        {!token && <Route path="/privacyPolicy" element={<PrivacyPolicy />}></Route>}
                        {!token && <Route path="/login" element={<Login />}></Route>}
                        {!token && <Route Route path='/verification' element={<Verification />}></Route>}
                        {!token && <Route path="/signup" element={<Signup />}></Route>}
                        {/* {!token && <Route Route path='/verification' element={<Verification />}></Route>} */}
                        <Route element={<AdminPrivate token={token} />}>
                            {allRoutes?.map((item) => {
                                if (!roles?.hide?.includes(item?.path)) return <Route key={item?.path} path={`/${item?.path}`} element={item?.element} ></Route>
                                return null
                            })}
                            {/* <Route path="/dashboard" element={<Dashboard />}></Route>
                            <Route path='/points' element={<Points />} ></Route>
                            <Route path='/salesRepDetail' element={<SalesRepresentativeViewDetail />} ></Route>
                            <Route path='/createSale' element={<CreateSale />} ></Route>
                            <Route path='/editSale' element={<EditSale />} ></Route>
                            <Route path='/saleRepresentative' element={<SaleRepresentative />} ></Route>
                            <Route path='/services' element={<Services />} ></Route>
                            <Route path='/services' element={<Services />} ></Route>
                            <Route path='/allObservantsUsers' element={<AllObserventsUsers />} ></Route>
                            <Route path='/createObservantUser' element={<CreateOberserventUser />} ></Route>
                            <Route path='/logs' element={<Logs />} ></Route>
                            <Route path='/approvalRequest' element={<ApprovalRequest />} ></Route>
                            <Route path='/allRegionalManagers' element={<AllRegionalManagers />} ></Route>
                            <Route path='/createManager' element={<CreateRegionalManager />} ></Route>
                            <Route path='/sales' element={<Sales />} ></Route> */}
                        </Route>
                        <Route path="*" element={token ? (<Navigate to="/dashboard" replace />) : (<Navigate to="/home" replace />)}></Route>
                    </Routes>
                </Suspense>
            </BrowserRouter >
        </>
    )
}

export default MyRoutes